<template>
    <!-- ログインしていて表示すべき予約一覧 -->
    <div v-if="isLogin && Reservations">
        <div class="demand-wrapper" v-if="Reservations.length > 0">
          <div v-for="r in Reservations" :key="r.id" class="index">
            <ItemIndexDemandReservation
              v-if="r.serviceName == area.name"
              :reservation="r"
              :service_id="area.master_bookingservice_id"
            />
          </div>
        </div>
    </div>
    <!-- 取得した予約可能なサービス一覧をループ表示 -->
</template>

<script>
export default {
name: "reservationsIndex",
props: {
    Reservations: {
      type: Array,
      required: true,
    },
    area: {
      type: Object,
      required: true,
    },
  },
  setup() {
  }
};
</script>

<style scoped lang="scss">
.demand-wrapper {
  padding: 2% 0;
}
.index {
  position: relative;
  clear: both;
  width: 96%;
  margin: auto;
}

</style>